<template>
	<div class="plate-intensity-chart" style="width: 100%; height: 80px;">
		<v-chart :options="chartOptions" autoresize theme="roma" style="width: 100%; height: 100%;" />
	</div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import 'echarts/lib/chart/line'
	import 'echarts/lib/component/tooltip'
	import 'echarts/lib/component/grid'
	export default {
		name: 'PlateIntensityChart',
		components: {
			'v-chart': ECharts
		},
		props: {
			days: {
				type: Array,
				default: () => []
			},
            trendData: {
                type: Array,
                default: () => []
            }
		},
        data() {
            return {
                chartData: []
            }
        },
        watch: {
            trendData: {
                handler() {
                    this.updateChart();
                },
                deep: true,
                immediate: true
            },
            days: {
                handler(val) {
                    if (val && val.length > 0) this.updateChart();
                }
            }
        },
        methods: {
            updateChart() {
                if (!this.trendData || this.trendData.length === 0 || !this.days || this.days.length === 0) {
                    this.chartData = [];
                    return;
                }
                
                const dataMap = {};
                this.trendData.forEach(item => {
                    dataMap[item.date1] = item.score;
                });

                this.chartData = this.days.map(day => {
                    return dataMap[day] !== undefined ? dataMap[day] : null;
                });
            }
        },
		computed: {
			chartOptions() {
				return {
					grid: {
						left: '0%',   // Align with the edge of the first column
						right: '0%',  // Align with the edge of the last column
						top: '25%',
						bottom: '5%',
                        containLabel: false
					},
					xAxis: {
						type: 'category',
						data: this.days,
						show: false, // Hide axis line/labels, just use for spacing
						boundaryGap: true // Centers the point in the band (column)
					},
					yAxis: {
						type: 'value',
						show: false,
                        min: 'dataMin' 
					},
					series: [{
						data: this.chartData.map(val => ({
                            value: val,
                            label: {
                                color: val < 0 ? '#00e400' : '#ff3333'
                            }
                        })),
						type: 'line',
						smooth: true,
                        symbol: 'circle',
                        symbolSize: 6,
						lineStyle: {
							color: '#999',
							width: 1
						},
						itemStyle: {
							color: '#fff',
                            borderColor: '#999',
                            borderWidth: 2
						},
						label: {
							show: true,
							position: 'top',
							// color: '#ff3333', // Overridden by data item
							fontWeight: 'bold',
                            fontSize: 12,
                            formatter: '{c}'
						}
					}]
				}
			}
		}
	}
</script>

<style scoped>
	.plate-intensity-chart {
		/* border: 1px dashed red; Debugging alignment */
	}
</style>
